import {useAppStore, useSessionStore, useAnnouncementStore} from '@/stores'
import {useTranslation} from 'i18next-vue'
import {messenger} from '@communication'
import {procedures} from '@communication'

export default class ConnectionFailedProcedure {
  constructor() {
    const {t} = useTranslation()
    this.name = 'conectionFailedProcedure'
    this.store = useAppStore()
    this.session = useSessionStore()
    this.t = t
  }

  install = () => {
    messenger.subscribe(this.name, 'strategy:failed', this.handler)
  }

  uninstall = () => {
    messenger.unsubscribe(this.name)
  }

  handler = () => {
    const announcement = useAnnouncementStore()
    announcement.showMessage(this.t('announcement.connectionFailed'), 'disconnect')
    this.session.sessionFailed = true
    messenger.emit('log:dumpTrigger', {reason: 'connection-failed'})
    setTimeout(() => {
      window.location.reload()
      procedures.get('destroyProcedure').silentlyDestroy()
    }, 5000)
  }
}
